var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8.24162 1 8.4375 1.18188 8.4375 1.40625V8.55048L11.3365 5.85857C11.5073 5.69992 11.7843 5.69992 11.9552 5.85857C12.126 6.01722 12.126 6.27445 11.9552 6.4331L8.30936 9.81851C8.1385 9.97716 7.8615 9.97716 7.69064 9.81851L4.04481 6.4331C3.87395 6.27445 3.87395 6.01722 4.04481 5.85857C4.21566 5.69992 4.49267 5.69992 4.66353 5.85857L7.5625 8.55048V1.40625C7.5625 1.18188 7.75838 1 8 1ZM1.4375 9.125C1.67912 9.125 1.875 9.30688 1.875 9.53125V12.2396C1.875 12.491 1.98255 12.7321 2.174 12.9099C2.36544 13.0876 2.62509 13.1875 2.89583 13.1875H13.1042C13.3749 13.1875 13.6346 13.0876 13.826 12.9099C14.0174 12.7321 14.125 12.491 14.125 12.2396V9.53125C14.125 9.30688 14.3209 9.125 14.5625 9.125C14.8041 9.125 15 9.30688 15 9.53125V12.2396C15 12.7065 14.8003 13.1542 14.4447 13.4844C14.0892 13.8145 13.607 14 13.1042 14H2.89583C2.39303 14 1.91081 13.8145 1.55528 13.4844C1.19974 13.1542 1 12.7065 1 12.2396V9.53125C1 9.30688 1.19588 9.125 1.4375 9.125Z",
    fill: "#5062F0",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.f257f55a653ae1850a24a2c0cb403a9b.svg";
export { ForwardRef as ReactComponent };